'use strict';

(function(window, document){
	// ----------------------------------- [START] Setting
	// Window 相關設定
	var w = window,
		win = $(window),
		ww,
		wh,
		ws,
		html = document.documentElement,
		body = document.body;

	// 取得Window設定值
	var windowSetting = function () {
		ww = win.innerWidth();
		wh = win.innerHeight();
		ws = win.scrollTop();
	}
	windowSetting();
	registerListener('resize', throttle(windowSetting, 50, 100));

	// -----------------------------
	// 取得裝置判斷
	var isMobile = false,
		isTablet = false,
		isPhone = false;
	var deviceDetect = function () {
		// IsPhone
		isPhone = ww <= 640;

		// IsMobile
		// 防止測試時一直用開發者工具Resize出現Bug
		isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

		// IsTablet
		if (navigator.userAgent.match(/Android/i)) {
			if (!navigator.userAgent.match(/Mobile/i)) {
				isTablet = true
			}
		} else if (navigator.userAgent.match(/BlackBerry|iPad|Opera Mini|IEMobile/i)) {
			isTablet = true
		}
	}
	deviceDetect();
	registerListener('resize', throttle(deviceDetect, 50, 100));
	// ----------------------------------- [END] Setting


	// 新增Header特殊固定(黑色區塊PC版不Fixed)
	body.classList.add('hd-fixed--main-nav-only');

})(window, document);

